export default {
	/**
	 * @description Este metodo debe ser ejecutado con apply o call para recibir el contexto
	 *  this del vue componente para que reconozca el $vs.loading y lo demas de la instancia
	 * @param {String} divId attributo id del div al cual se le aplicara la animacion
	 * @param {String} colorBtnLoading color del loading por defecto blanco
	 */
	openLoadingDiv(divId, colorDivLoading = "primary") {
		this.$vs.loading({
			color: colorDivLoading,
			container: "#" + divId,
			scale: 0.6,
		});
	},
	/**
	 * @description Metodo detiene la animacion del div, debe ser ejecutado con apply o call para recibir el contexto
	 * @param {String} divId attributo id del div al cual se detendra la animacion
	 */
	closeLoadingDiv(divId) {
		this.$vs.loading.close("#" + divId + " > .con-vs-loading");
	},
	/**
	 * @description Este metodo debe ser ejecutado con apply o call para recibir el contexto
	 *  this del vue componente para que reconozca el $vs.loading y lo demas de la instancia
	 * @param {String} btnId attributo id del boton al cual se le aplicara la animacion
	 * @param {String} backgroundBtnLoading color del boton cuando se esta animando por defecto primary
	 * @param {String} colorBtnLoading color del loading por defecto blanco
	 */
	openLoadingButton(btnId, backgroundBtnLoading = "primary", colorBtnLoading = "#fff") {
		this.$vs.loading({
			background: backgroundBtnLoading,
			color: colorBtnLoading,
			container: "#" + btnId,
			scale: 0.45,
		});
	},
	/**
	 * @description Metodo detiene la animacion del boton, debe ser ejecutado con apply o call para recibir el contexto
	 * @param {String} btnId attributo id del boton al cual se detendra la animacion
	 */
	closeLoadingButton(btnId) {
		this.$vs.loading.close("#" + btnId + " > .con-vs-loading");
	},
	/**
	 * @description generate array data for any selection component
	 * @param {Array} data Array
	 * @param {String} propLabel propertie name from array for crete label propertie
	 * @param {Strig} propValue propertie name from array for crete value propertie
	 */
	generateSelectOptios(data, propLabel, propValue) {
		return data.map((d) => {
			return {label: d[propLabel], value: d[propValue]};
		});
	},
	/**
	 * @description Method to validate some commons errors
	 * @param {Object} err is object containt  whit the error descriptions
	 * @param {String} moduleName is the name of module when the method is called
	 */
	manageError(err, moduleName = "all", methodName = "all") {
		if (!err) return;
		const errorInfo = this.processError(err, moduleName, methodName);
		this.$vs.notify({
			color: errorInfo.color,
			title: errorInfo.title,
			text: errorInfo.text,
			time: 7000,
			icon: "warning",
		});
	},
	processError(err, moduleName, methodName) {
		const errorData = this.getErrorData(err);
		let title = this.$t("ErrorTitle");
		let text = "";
		let color = "warning";
		switch (errorData.errorType) {
			case "array":
				({title, text} = this.handleArrayError(errorData.errorData));
				break;
			case "object":
				if (errorData.errorData) {
					({title, text, color} = this.handleSpecificError(errorData.errorData, moduleName, methodName));
				}
				break;
			case "message":
				if (errorData.errorMessage === "The requested resource doesn't exist") {
					title = this.$t("Permissions.RequiredPermissions");
					text = `${this.$t("Roles.Permissions.RequiredPermissionsText")} GOTU`;
				}
				break;
			default:
				text = `Status error : ${err.status}, ${err.message}`;
		}
		return {title, text, color};
	},
	getErrorData(error) {
		if (error && error.data) {
			return Array.isArray(error.data.error)
				? {errorType: "array", errorData: error.data.error}
				: {errorType: "object", errorData: error.data.error || null};
		}
		return error && error.message
			? {errorType: "message", errorMessage: error.message}
			: {errorType: "default", errorMessage: null};
	},
	handleArrayError(errorData) {
		const errorMessage = errorData.map(
			({absolute_path, message}) =>
				`${absolute_path[0].replaceAll("_", " ").toUpperCase()}: ${this.validatorMessage(message)}`
		);
		return {
			title: this.$t("ErrorTitle"),
			text: `${this.$t("ManualData.Property")} ${errorMessage[0]}`,
		};
	},
	validatorMessage(message) {
		const validatorMessageMap = new Map([
			["is too short", "ManualData.TooShortProperties"],
			["[] is too short", "DesignConfig.SelectMinimumOneOption"],
			["is not one of", "DesignConfig.SelectMinimumOneOption"],
		]);
		for (const [key, value] of validatorMessageMap) {
			if (message.includes(key)) return this.$t(value);
		}
		return this.$t("ManualData.ValidatorRequiredProperty");
	},
	handleSpecificError(errorData, moduleName, methodName) {
		const specificErrorMap = new Map([
			[
				"Scheduling api not enabled for this company.",
				{title: this.$t("Schedule.ActiveApi"), text: this.$t("Schedule.SchedulingApiNotEnabled")},
			],
			[
				"Serviforms api not enabled for this company.",
				{title: this.$t("Schedule.ActiveApi"), text: this.$t("Schedule.ServiformApiNotEnabled")},
			],
			[
				"Unexpected Error: config list is empty!",
				{title: this.$t("ActivityList"), text: this.$t("Activity.ActivityListEmpty")},
			],
		]);
		const errorObject = specificErrorMap.get(errorData);
		if (errorObject) return errorObject;

		if (errorData === "invalid values" && moduleName === "CompanyConfigCrudForm") {
			const keys = Object.hasOwnProperty.call(err.data, "keys") ? err.data.keys.join(" , ") : "";
			const title = this.$t("ErrorTitle");
			const color = "danger";
			const text =
				methodName === "update"
					? `${this.$t("UpdateCompanyConfigErrorMessage")}; ${keys} ${this.$t("IvalidValuesErrorMessage")}`
					: `${this.$t("TitleSuccessTypeConfigCreatedError")}; ${keys} ${this.$t(
							"IvalidValuesErrorMessage"
					  )}`;
			return {title, text, color};
		}

		return {
			title: this.$t("ErrorTitle"),
			text: `Status error : ${err.status}, ${err.message}`,
		};
	},
	/**
	 * @description Method to validate some commons errors
	 * @param {Object} err is object containt  whit the error descriptions
	 */

	manageErrorValidator(err) {
		const title = this.$t("ErrorTitle");
		if (!err) {
			return {title, text: ""};
		}
		const {message, validator} = this.getErrorDataValidator(err);
		if (!message) {
			return {title, text: ""};
		}
		if (validator === "backend") {
			return this.handleBackendError(message, title);
		} else if (validator) {
			return this.handleValidatorError(validator, title);
		}
		return this.handleGeneralError(message, title);
	},
	getErrorDataValidator(error) {
		if (!error) return {message: "", validator: null};
		const errorData = error.data || {};
		const errorArr = error.error || errorData.error || [];
		if (Array.isArray(errorArr)) {
			return {message: errorArr[0].message || "", validator: errorArr[0].validator || null};
		}
		return {message: error.message || "", validator: null};
	},
	handleBackendError(message, title) {
		const backendMessages = new Map([
			[
				"Scheduling api not enabled for this company.",
				{title: this.$t("Schedule.ActiveApi"), text: this.$t("Schedule.SchedulingApiNotEnabled")},
			],
			[
				"Serviforms api not enabled for this company.",
				{title: this.$t("Schedule.ActiveApi"), text: this.$t("Schedule.ServiformApiNotEnabled")},
			],
			[
				"visit point not registered",
				{title: this.$t("ManualData.identification"), text: this.$t("ManualData.NotRegistered")},
			],
			[
				"Date less than current date",
				{title: this.$t("ManualData.date"), text: this.$t("ManualData.DateLessThanCurrentDate")},
			],
			[
				"activity not registered",
				{title: this.$t("Activity.Activity"), text: this.$t("ManualData.ActivityNotRegistered")},
			],
			["already exist.", {title: this.$t("ErrorTitle"), text: this.$t("ManualData.AlreadyRegistered")}],
			["Existing identification.", {title: this.$t("ErrorTitle"), text: this.$t("ManualData.AlreadyRegistered")}],
			["Already registered", {title: this.$t("ErrorTitle"), text: this.$t("ManualData.AlreadyRegistered")}],
			["Init hour greater than end hour", {title: this.$t("ErrorTitle"), text: this.$t("Schedule.ValidEndOur")}],
			[
				"The address could not be georeferenced",
				{title: this.$t("ErrorTitle"), text: this.$t("ManualData.AddressCouldBeNotGeoreferenced")},
			],
			[
				"coordinates could not be found",
				{title: this.$t("ErrorTitle"), text: this.$t("ManualData.CoordinatesCouldBeNotFound")},
			],
			["error_date", {title: this.$t("ErrorTitle"), text: this.$t("ManualData.ErrorDate")}],
			["error_init_hour", {title: this.$t("ErrorTitle"), text: this.$t("ManualData.ErrorInitHour")}],
			["error_end_hour", {title: this.$t("ErrorTitle"), text: this.$t("ManualData.ErrorEndHour")}],
			[
				"Init hour less than current time",
				{title: this.$t("ErrorTitle"), text: this.$t("ManualData.InitHourLessThanCurrentTime")},
			],
			[
				"Duplicate record in excel",
				{title: this.$t("ErrorTitle"), text: this.$t("ManualData.DuplicateRecordInExcel")},
			],
			["Dane code not found", {title: this.$t("ErrorTitle"), text: this.$t("ManualData.DaneCodeNotFound")}],
			["Save record error", {title: this.$t("ErrorTitle"), text: this.$t("ManualData.SaveRecordError")}],
			[
				"Activity not available for the resource",
				{title: this.$t("ErrorTitle"), text: this.$t("Schedule.ActivityNoAvailable")},
			],
			[
				"Resource has no activities",
				{title: this.$t("ErrorTitle"), text: this.$t("ManualData.ResourceHasNoActivities")},
			],
		]);
		const backendError = backendMessages.get(message);
		if (backendError) {
			return backendError;
		}
		return {title, text: this.translateMessage(message)};
	},
	handleValidatorError(validator, title) {
		const validatorMap = new Map([
			["required", "ManualData.ValidatorRequiredProperty"],
			["additionalProperties", "ManualData.ValidatorAdditionalProperties"],
			["minLength", "ManualData.TooShortProperties"],
			["minimum", "Optimization.Messages.minimum"],
			["enum", "Optimization.Messages.enum"],
			["type", "Optimization.Messages.type"],
			["pattern", "Optimization.Messages.pattern"],
			["format", "Optimization.Messages.format"],
			["maximum", "Optimization.Messages.maximum"],
			["maxLength", "Optimization.Messages.maxLength"],
			["minItems", "Optimization.Messages.minItems"],
			["maxItems", "Optimization.Messages.maxItems"],
		]);
		const translatedText = validatorMap.get(validator);
		if (translatedText) {
			return {title, text: this.$t(translatedText)};
		}
		return {title, text: this.translateMessage(validator)};
	},
	handleGeneralError(message, title) {
		return {title, text: this.translateMessage(message)};
	},
	translateMessage(message) {
		const messageMap = new Map([
			["Already registered", "ManualData.AlreadyRegistered"],
			["Existing identification.", "ManualData.AlreadyRegistered"],
			["Date less than current date", "ManualData.DateLessThanCurrentDate"],
			["Not registered", "ManualData.NotRegistered"],
			["is a required property", "ManualData.ValidatorRequiredProperty"],
			["Init hour greater than end hour", "Schedule.ValidEndOur"],
			["The address could not be georeferenced", "ManualData.AddressCouldBeNotGeoreferenced"],
			["coordinates could not be found", "ManualData.CoordinatesCouldBeNotFound"],
			["error_date", "ManualData.ErrorDate"],
			["error_init_hour", "ManualData.ErrorInitHour"],
			["error_end_hour", "ManualData.ErrorEndHour"],
			["Init hour less than current time", "ManualData.InitHourLessThanCurrentTime"],
			["Duplicate record in excel", "ManualData.DuplicateRecordInExcel"],
			["Dane code not found", "ManualData.DaneCodeNotFound"],
			["Save record error", "ManualData.SaveRecordError"],
			["Activity not available for the resource", "Schedule.ActivityNoAvailable"],
			["Resource has no activities", "ManualData.ResourceHasNoActivities"],
			["does not match", "Email"],
			["time data", "ManualData.TimeDataFormat"],
		]);
		for (const [key, value] of messageMap) {
			if (message.includes(key)) {
				return this.$t(value);
			}
		}
		return message;
	},
	findErrorNamePropertyValidator() {
		return function validator(error) {
			let errorProperty = null;
			if (error.data === null) {
				errorProperty = error.error;
			} else {
				errorProperty = error.data.error;
			}
			const absolute_path = errorProperty[0].absolute_path.length > 0 ? errorProperty[0].absolute_path[1] : "";
			if (absolute_path === "additional_info") {
				let message = errorProperty[0].message;
				const expresion = /'(.*)'/gm;
				const foundMatch = message.match(expresion);
				if (error.error[0].absolute_path.length > 1) {
					return errorProperty[0].absolute_path[1];
				}
				return foundMatch ? foundMatch[0].replace(/'/g, "") : message;
			} else {
				return errorProperty[0].absolute_path[0];
			}
		};
	},
	findErrorNameProperty() {
		return function validator(error) {
			let errorProperty = null;
			if (error.data === null) {
				errorProperty = error.error;
			} else {
				errorProperty = error.data.error;
			}
			if (!errorProperty[0].hasOwnProperty("message")) {
				return "";
			}
			const message = errorProperty[0].message;
			if (message) {
				const expresion = /\[(.*?)'\]/gm;
				const foundMatch = message.match(expresion);
				return foundMatch ? foundMatch[0].replace(/['[\]]/g, "") : message;
			} else {
				return message;
			}
		};
	},
};
